"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function htmlToElement(html) {
    var div = document.createElement('div');
    div.innerHTML = html.trim();
    return div.firstChild;
}
exports.default = htmlToElement;
//# sourceMappingURL=htmlToElement.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/htmlToElement.js
// module id = 4
// module chunks = 0